import React from "react";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  ArrowSwapHorizontal,
  Candle,
  Coin1,
  Moon,
  Sun1,
  Wallet3,
} from "iconsax-react";
import { useTranslation } from "react-i18next";
import { useLanguageProvider } from "../../providers/LanguageProvider";
import { useThemeProvider } from "../../providers/ThemeProvider";
import LanguageSelectorDialogComponent from "../dialogs/LanguageDialogComponent";
import { LinkValues } from "../../values/strings";
import { QuestionAnswer, QuestionMark } from "@mui/icons-material";

export const MainDrawerListViewComponent = () => {
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  const theme = useThemeProvider();
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = React.useState(false);

  const handleChangeTheme = () => {
    theme.setTheme(
      theme.theme.palette.mode == "dark"
        ? theme.styles.light
        : theme.styles.dark
    );
  };
  return (
    <Grid container direction="column">
      <Grid item>
        <List>
          <ListItem disablePadding>
            <ListItemButton
              href={LinkValues.routes.initLocale(
                LinkValues.routes.market.self(false),
                lang.supportedLanguages
              )}
            >
              <Grid container padding="5px 0" columnGap={1}>
                <Grid container item xs="auto" alignContent="center">
                  <Candle size={17} />
                </Grid>
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("markets")}</Typography>
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>

          {/* <ListItem disablePadding>
            <ListItemButton
              href={LinkValues.routes.initLocale(
                LinkValues.routes.trade.self(false),
                lang.supportedLanguages
              )}
            >
              <Grid container padding="5px 0" columnGap={1}>
                <Grid container item xs="auto" alignContent="center">
                  <ArrowSwapHorizontal size={17} />
                </Grid>
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("buysell")}</Typography>
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem> */}

          <ListItem disablePadding>
            <ListItemButton
              href={LinkValues.routes.initLocale(
                LinkValues.routes.wallet.self(false),
                lang.supportedLanguages
              )}
            >
              <Grid container padding="5px 0" columnGap={1}>
                <Grid container item xs="auto" justifyContent="flex-end">
                  <Wallet3 size={17} />
                </Grid>
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("wallet")}</Typography>
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              href={LinkValues.routes.initLocale(
                LinkValues.routes.earn.self(false),
                lang.supportedLanguages
              )}
            >
              <Grid container padding="5px 0" columnGap={1}>
                <Grid container item xs="auto" alignContent="center">
                  <Coin1 size={17} />
                </Grid>
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("earn")}</Typography>
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              href={LinkValues.routes.initLocale(
                LinkValues.routes.about.self(false),
                lang.supportedLanguages
              )}
            >
              <Grid container padding="5px 0" columnGap={1}>
                <Grid container item xs="auto" alignContent="center">
                  <QuestionMark size={17} />
                </Grid>
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("about")}</Typography>
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>

          <Divider />

          <ListItem disablePadding>
            <ListItemButton onClick={() => setIsLanguageMenuOpen(true)}>
              <Grid container padding="5px 0">
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("language")}</Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs="auto"
                  alignContent="center"
                  justifyContent="flex-end"
                >
                  <Typography variant="navBar">
                    {t(`lang_${i18n.resolvedLanguage}_name`)}
                  </Typography>
                </Grid>
              </Grid>
            </ListItemButton>
            <LanguageSelectorDialogComponent
              isOpen={isLanguageMenuOpen}
              onClose={() => setIsLanguageMenuOpen(false)}
            />
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={handleChangeTheme}>
              <Grid container padding="5px 0">
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("theme")}</Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs="auto"
                  alignContent="center"
                  justifyContent="flex-end"
                >
                  {(theme.theme.palette.mode === "dark" && (
                    <Sun1 size={17} />
                  )) || <Moon size={17} />}
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
        </List>
      </Grid>
      <Grid container item padding={1} direction="column">
        <Button
          color={"secondary"}
          variant="contained"
          href={LinkValues.routes.initLocale(
            LinkValues.routes.auth.login(false),
            lang.supportedLanguages
          )}
          disableElevation
          disableRipple
        >
          <Typography variant="navBar">{t("log_in")}</Typography>
        </Button>
      </Grid>
      <Grid container item padding={1} direction="column">
        <Button
          color={"primary"}
          variant="contained"
          href={LinkValues.routes.initLocale(
            LinkValues.routes.auth.register(false),
            lang.supportedLanguages
          )}
          disableElevation
          disableRipple
        >
          <Typography variant="navBar">{t("sign_up")}</Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

export const SimpleDrawerListViewComponent = () => {
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  const theme = useThemeProvider();
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = React.useState(false);

  const handleChangeTheme = () => {
    theme.setTheme(
      theme.theme.palette.mode == "dark"
        ? theme.styles.light
        : theme.styles.dark
    );
  };
  return (
    <Grid container direction="column">
      <Grid item>
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => setIsLanguageMenuOpen(true)}>
              <Grid container padding="5px 0">
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("language")}</Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs="auto"
                  alignContent="center"
                  justifyContent="flex-end"
                >
                  <Typography variant="navBar">
                    {t(`lang_${i18n.resolvedLanguage}_name`)}
                  </Typography>
                </Grid>
              </Grid>
            </ListItemButton>
            <LanguageSelectorDialogComponent
              isOpen={isLanguageMenuOpen}
              onClose={() => setIsLanguageMenuOpen(false)}
            />
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={handleChangeTheme}>
              <Grid container padding="5px 0">
                <Grid
                  container
                  item
                  xs
                  alignContent="center"
                  justifyContent="flex-start"
                >
                  <Typography variant="navBar">{t("theme")}</Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs="auto"
                  alignContent="center"
                  justifyContent="flex-end"
                >
                  {(theme.theme.palette.mode === "dark" && (
                    <Sun1 size={17} />
                  )) || <Moon size={17} />}
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
        </List>
      </Grid>
    </Grid>
  );
};
